<template>
  <div class="hello">
    <h1 id="montserrat">{{ msg }}</h1>
    <br />
    <br />
    <br />
    <b-container class="bv-example-row">
      <form @submit="login">
        <div class="form-group">
          <strong class="text-left" id="montserrat">Email:</strong>
          <input
            type="email"
            class="form-control"
            v-model="username"
            placeholder
            required
            oninvalid="this.setCustomValidity('Email is required')"
            oninput="setCustomValidity('')"
          />

          <strong class="text-left" id="montserrat">Password:</strong>
          <input
            type="password"
            class="form-control"
            v-model="password"
            placeholder
            required
            oninvalid="this.setCustomValidity('Password is required')"
            oninput="setCustomValidity('')"
          />
        </div>
        <button :disabled="clicked" class="btn btn-primary">Login</button>
      </form>
      <br />
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import { AUTH_REQUEST } from "../store/actions/auth";

export default {
  name: "Login",
  props: {
    msg: String
  },
  data() {
    return {
      username: "me@me.com",
      password: "TheFancyMutt1!",
      clicked: false
    };
  },
  methods: {
    login(e) {
      //   this.clicked = true;
      e.preventDefault();
      const { username, password } = this;
      this.$store.dispatch(AUTH_REQUEST, { username, password }).then(() => {
        this.password = "";
        this.$router.push("/").catch(error => {
          console.info(error.message);
        });
      });
    },
    healthCheck(e) {
      e.preventDefault();
      axios
        .get(process.env.VUE_APP_API_SERVER.concat("/v1/health/auth"), {})
        .then(response => console.log(response.data))
        .catch(error => console.log(error))
        .finally(() => (this.loading = false));
    },
    mounted() {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>